var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2b80f353e0cd9b20b6217447221397eb6a9341bc"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["buscounchollo-prod@sentry"]={id:"2b80f353e0cd9b20b6217447221397eb6a9341bc"};
      